import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './Context/AuthContext';
import { Toaster } from 'react-hot-toast';
import { ProductLibraryProvider } from './Context/ProductLibraryContext';
import { UnsavedChangesProvider } from './Context/UnsavedChangesContext';

// A data router (instead of <BrowserRouter>) is what lets useBlocker stop navigation away from
// a page with unsaved changes. The app's own <Routes> still live inside App.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <UnsavedChangesProvider>
        <AuthProvider>
          <ProductLibraryProvider>
            <App />
            <Toaster position="top-center"/>
          </ProductLibraryProvider>
        </AuthProvider>
      </UnsavedChangesProvider>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
